<template>
  <v-app v-resize="onResize">
    <v-content>
      <router-view v-if="$variables.loaded == 0 && routeName != 'login'" />
      <Login v-if="routeName == 'login'"></Login>
    </v-content>

    <Congratulation
      ref="congratulation"
    ></Congratulation>

    <ReachedGoalModal ref="reachedGoalModal"></ReachedGoalModal>

    <VisaApproved ref="visaApproved"></VisaApproved>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Congratulation from "./views/Congratulation";
import Centrifuge from "centrifuge/dist/centrifuge.protobuf";
import Login from "./views/Login";
import auth from '@/mixins/auth';
import './widgets.scss';
import VisaApproved from "./components/modals/VisaApproved";
import ReachedGoalModal from "@/components/modals/ReachedGoalModal";
import {STATS_ROLES} from "./config/constants";

export default {
  name: "App",
  components: {
      VisaApproved,
      Congratulation,
      ReachedGoalModal,
      Login,
  },
  data() {
    return {
      skipNextBoardsSettingsStream: false,
      centrifuge: null,
    }
  },
  mixins: [auth],
  methods: {
    onResize() {
      const BOARD_TITLE_H = 74;
      this.$variables.appHeight = window.innerHeight - BOARD_TITLE_H;
      this.$variables.appWidth = window.innerWidth;
    },
    ...mapGetters(["userRole"]),
    syncSalesStatsEndpoint() {
      const { meta } = this.$route;

      const useV2 = meta.salesStatsVersion === 'v2'
        || this.$store.state.boards.useNewVersion;

      const endpoint = useV2
        ? 'sync/sales_stats/v2'
        : 'sync/sales_stats';

      const changed = this.$store.state.streams.salesStatsEndpoint !== endpoint;

      if (changed) {
        this.setSalesStatsEndpoint(endpoint);
      }

      return changed;
    },
    usesSalesStatsRoute() {
      return ['home', 'home-v2', 'dashboard'].includes(this.routeName);
    },
    ...mapActions({
      getBoards: "boards/getBoards",
      getStreams: "streams/getStreams",
      getStreamsNew: "streams/getStreamsNew",
      setSalesStatsEndpoint: "streams/setSalesStatsEndpoint",
      replaceBoards: "replaceBoards",
      replaceStream: "replaceStream",
      dynamicUpdateProducts: "productsStatistic/dynamicUpdateProducts",
      dynamicUpdateAgentPoints: "agentPointsList/dynamicUpdateAgentPoints",
    }),

    connect() {
      if (this.centrifuge) {
        return;
      }

      const webSocketURL = process.env.VUE_APP_CENT_URL;

      const centrifuge = new Centrifuge(webSocketURL);

      centrifuge.setToken(this.$store.state.app.cent_token);

      centrifuge.subscribe("sale_boards_settings_stream", (message) => {
        if (this.skipNextBoardsSettingsStream) {
          this.skipNextBoardsSettingsStream = false;
          return;
        }

        const data = JSON.parse(
          new TextDecoder("utf-8").decode(message.data)
        );
        this.replaceBoards(data);

        if (this.usesSalesStatsRoute() && this.syncSalesStatsEndpoint()) {
          this.getStreams();
        }

        this.dynamicUpdateProducts();
        this.dynamicUpdateAgentPoints();
      });

      if (!STATS_ROLES.includes(this.userRole())) {
        centrifuge.subscribe("sale_boards_statistics_stream", (message) => {
          const data = JSON.parse(
            new TextDecoder("utf-8").decode(message.data)
          );
          this.replaceStream(data);
          this.dynamicUpdateProducts();
          this.dynamicUpdateAgentPoints();
        });
      }

      centrifuge.subscribe("successful_payments_stream", (message) => {
        const data = JSON.parse(
          new TextDecoder("utf-8").decode(message.data)
        );
        
        const activeBoard = this.$store.state.boards.active;

        if (activeBoard) {
          const board = this.$store.state.boards.boards[activeBoard];
          const role = board ? board.default_role : null;

          if ((this.$store.state.boards.agentsCrmIdsPerBoard || []).includes(data.user_crm_id)) {
            this.$bus.$emit('successful_payments_stream', {
              role: data.user_role,
              board: role,
            })

          this.$refs.congratulation.open(data);
        }
        }
      });

      centrifuge.subscribe("positive_result_stream", (message) => {
          const data = JSON.parse(
              new TextDecoder("utf-8").decode(message.data)
          );
          this.$refs.visaApproved.open(data);
      });

      centrifuge.connect();
      this.centrifuge = centrifuge;
    },
  },

  computed: {
    board() {
      return this.$store.state.boards.active ? this.$store.state.boards.boards[this.$store.state.boards.active] : null;
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    '$route'() {
      if (this.routeName === 'login') {
        return;
      }

      if (!this.usesSalesStatsRoute()) {
        return;
      }

      if (this.syncSalesStatsEndpoint()) {
        this.getStreams();
      }
    },
  },
  mounted() {
    if (this.routeName != "login") {
      this.getBoards().then(() => {
        this.syncSalesStatsEndpoint();
        this.getStreams();
        this.skipNextBoardsSettingsStream = true;
        this.connect();
      });
    }

    this.$bus.$on("show_reached_goal_modal", (data) => {
        this.$refs.reachedGoalModal.open(data);
    });
  },
};
</script>

<style lang="scss">
.body,
html {
  overflow: hidden !important;
}

// .material-icons {
//   font-family: "Material Design Icons";
// }

.vue-grid-item::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}
.vue-grid-item {
  transition: 0.2s;
}

.vue-grid-item::-webkit-scrollbar-thumb {
  height: 6px;
  border: 4px solid transparent;
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: transparent;
  transition: 0.2s;
  -webkit-box-shadow: inset -1px -1px 0px transparent,
    inset 1px 1px 0px transparent;
}

.vue-grid-item:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border: 4px solid rgba(0, 0, 0, 0);
  transition: 0.2s;
  -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05),
    inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}

.vue-grid-item::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.vue-grid-item::-webkit-scrollbar-corner {
  background-color: transparent;
}


</style>
